import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left-1",
  "use": "arrow-left-1-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-left-1\">\n<path d=\"M4 6.50002C4 6.37215 4.04887 6.24415 4.1465 6.14652L9.14647 1.1465C9.34185 0.951199 9.65822 0.951199 9.85347 1.1465C10.0487 1.3419 10.0488 1.6583 9.85347 1.8535L5.20699 6.50002L9.85347 11.1465C10.0488 11.3419 10.0488 11.6583 9.85347 11.8535C9.6581 12.0488 9.34172 12.0489 9.14647 11.8535L4.1465 6.85352C4.04887 6.7559 4 6.6279 4 6.50002Z\" fill=\"#202022\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol